import { Dialog, DialogActions, DialogContent, TextField } from '@mui/material';
import * as api from "api/Knowledge";
import ButtonCopyToClipboard from 'components/Buttons/ButtonCopyToClipboard';
import ButtonExport from 'components/Buttons/ButtonExport';
import { RequestIndicator } from 'components/CallServer';
import MuiMessageBox from 'components/MuiExtras/MessageBox/MuiMessageBox';
import MuiDialogTitleClose from 'components/MuiExtras/MuiDialogTitleClose';
import { WithSnackbar, withSnackbar } from 'components/SnackbarProvider/Snackbar';
import HtmlUtils from 'lib/HtmlUtils';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    data: string;
    lastError: any;
    loading: boolean;
}

interface IProps {
    publicationId?: string;
    fileId?: string;
    subtitle: string;
    onClose: () => void;
}

type Props = IProps & WithTranslation & WithSnackbar;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

class TranscriptionSubtitleDialog extends React.PureComponent<Props, IState> {
    private textAreaRef: HTMLTextAreaElement;

    constructor(props: Props) {
        super(props);
        this.state = {
            data: null,
            lastError: null,
            loading: true,
        };
    }

    ///
    private loadData() {
        this.setState({ loading: true });

        const fn = (this.props.fileId)
            ? api.getFileSubtitle(this.props.fileId)
            : api.getMetadataSubtitle(this.props.publicationId);

        fn
            .then((data) => {
                this.setState({ data, loading: false });
            })
            .catch((error) => {
                this.setState({ lastError: error, loading: false });
            });
    }

    ///
    private handleCopyToClipboard(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        this.textAreaRef.select();
        document.execCommand('copy');
        e.currentTarget.focus();
        this.props.snackbar.showMessage(this.props.t("Common.Literals.CopyToClipboardSuccess"));
    };

    /// 
    private handleExport() {
        if (this.props.fileId) HtmlUtils.download(`/api/v1.0/Knowledge/ExportFileSubtitle/${this.props.fileId}`);
        else if (this.props.publicationId) HtmlUtils.download(`/api/v1.0/Knowledge/ExportMetadataSubtitle/${this.props.publicationId}`);
    };


    ///
    public componentDidMount() {
        this.loadData();
    }

    ///
    public render() {
        const { subtitle, onClose } = this.props;
        const { data, lastError, loading } = this.state;


        return (
            <Dialog
                open
                fullWidth
                maxWidth="md"
                onClose={() => onClose()}
            >
                <MuiDialogTitleClose
                    title={this.props.t("Views.Timeline.Dialogs.TranscriptionSubtitleDialog.BoxTitle")}
                    subtitle={subtitle}
                    onClose={() => onClose()}
                />

                <DialogContent>

                    {loading && <RequestIndicator type={"request"} />}

                    {
                        lastError
                            ? <MuiMessageBox variant="error" message={this.props.t("Views.Timeline.Dialogs.TranscriptionSubtitleDialog.LoadError")} />
                            : (
                                <TextField
                                    multiline
                                    variant="outlined"
                                    rows={15}
                                    value={data || ""}
                                    style={{ width: "100%" }}
                                    inputRef={(ref) => this.textAreaRef = ref}
                                    InputProps={
                                        {
                                            readOnly: true,
                                        }
                                    }
                                />
                            )
                    }

                </DialogContent>

                <DialogActions>
                    {
                        !loading && !lastError
                            ? (
                                <>
                                    {
                                        document.queryCommandSupported('copy') &&
                                        <ButtonCopyToClipboard color="info" onClick={(e) => this.handleCopyToClipboard(e)} />
                                    }

                                    <ButtonExport color="warning" onClick={() => this.handleExport()} />
                                </>
                            )
                            : <span>&nbsp;</span>
                    }
                </DialogActions>
            </Dialog>
        );
    }
}

export default withSnackbar(withTranslation()(TranscriptionSubtitleDialog));